module.exports = __webpack_public_path__ + "images/3ad5d54da8e9c6827e1ba88d30ff840b.png";